import React from "react";

const RenderError = ({ component }) => {
    return (
        <div className='pt-10 pb-10'>
            <h2>Something went wrong.</h2>
            <details style={{ whiteSpace: 'pre-wrap' }}>
                Has error, please see error in console or check <b>{component}</b> component!!
            </details>
        </div>
    )
}

export default RenderError